import { DsLoadingSize } from '@type/ds-loading-size.type';
import { DsLoadingSpinnerMetric } from '@design-system/ds-loading-spinner/types/ds-loading-spinner-metric.type';
import {
  DS_LOADING_SPINNER_DIAMETER,
  DS_LOADING_SPINNER_STROKE_WIDTH,
} from '@design-system/ds-loading-spinner/properties/ds-loading-spinner.properties';

/**
 * Returns the circular spinner diameter or stroke width for a size variant.
 *
 * @param size - Spinner size variant
 * @param metric - Whether to resolve diameter or stroke width
 * @param override - Optional pixel override; used when not null
 * @returns Pixel value to apply to `mat-progress-spinner`
 */
export function getDsLoadingSpinnerMetric(
  size: DsLoadingSize,
  metric: DsLoadingSpinnerMetric,
  override: number | null | undefined,
): number {
  if (override !== null && override !== undefined) {
    return override;
  }

  if (metric === 'diameter') {
    return DS_LOADING_SPINNER_DIAMETER[size];
  }

  return DS_LOADING_SPINNER_STROKE_WIDTH[size];
}
